<template>
  <div class="mailing-fields">
    <SettingsField v-if="hasFlag('push_notification_schedule')" :label="$t('platform.schedule')" :hint="$t('platform.card.fields.schedule')">
      <WorkingSchedule :initial-schedule="form.schedule_days" :select-all="selectAllSchedule" @update:schedule="form.schedule_days = $event" />
      <small class="mailing-fields__note">
        <svg v-svg symbol="info" size="0 0 15 15" role="info"></svg>
        {{ $t("platform.local_timezone") }}
      </small>
    </SettingsField>

    <SettingsField :label="$t('platform.mailing_frequency')" :hint="$t('platform.card.fields.mailing_frequency')" :tooltip="$t('platform.notifs_amount_popup')" tooltipHtml>
      <custom-multiselect v-model="form.mailing_frequency" :list="options.mailings" :allowEmpty="false">
        <template v-slot:block="props">
          <span>{{ props.value.title }}</span>
        </template>
        <template v-slot:list="props">
          <span>{{ props.value.title }}</span>
        </template>
      </custom-multiselect>
    </SettingsField>

    <SettingsField v-if="hasFlag('push_delay_interval')" :label="$t('platform.push_delay_send')" :hint="`${$t('platform.how_long_push_delay')}.`">
      <custom-multiselect v-model="form.push_delay_interval" :list="options.pushDelays" :allowEmpty="false">
        <template v-slot:block="props">
          <span>{{ props.value.title }}</span>
        </template>
        <template v-slot:list="props">
          <span>{{ props.value.title }}</span>
        </template>
      </custom-multiselect>
    </SettingsField>

    <SettingsField v-if="hasFlag('custom_push_send_interval')" :label="$t('platform.push_interval')" :hint="`${$t('platform.card.fields.push_interval')} ${$t('platform.default_may_be_changed')}.`">
      <custom-multiselect v-model="form.push_send_interval" :list="options.pushIntervals" :allowEmpty="false">
        <template v-slot:block="props">
          <span>{{ intervalTitle(props.value) }}</span>
        </template>
        <template v-slot:list="props">
          <span>{{ intervalTitle(props.value) }}</span>
        </template>
      </custom-multiselect>
    </SettingsField>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SettingsField from "@/components/PlatformCard/SettingsField.vue";
import WorkingSchedule from "@/components/WorkingSchedule.vue";

// When and how often the platform's subscribers get pushes. Edits `form` in place: schedule_days,
// mailing_frequency, push_delay_interval, push_send_interval.
export default {
  name: "MailingFields",
  components: { SettingsField, WorkingSchedule },
  props: {
    form: {
      type: Object,
      required: true,
    },
    // mailings, pushDelays, pushIntervals
    options: {
      type: Object,
      required: true,
    },
    selectAllSchedule: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      featureFlags: "user/getFeatureFlags",
    }),
  },
  methods: {
    hasFlag(flag) {
      return Boolean(this.featureFlags && this.featureFlags.includes(flag));
    },
    intervalTitle(interval) {
      return interval && interval.title === "Default" ? this.$t("default") : interval && interval.title;
    },
  },
};
</script>
<style lang="scss" scoped>
.mailing-fields__note {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 12px;
  color: #9b9ba4;

  svg {
    fill: #9b9ba4;
  }
}
</style>
